const toggleStyles = theme => ({
  // Force override of styles from AntD
  "form input[type='checkbox'].toggle-peer": {
    width: '46px',
    height: '26px',
  },

  '.toggle-button': {
    boxShadow: '0px 3px 8px rgba(19, 20, 21, 0.1)',
  },
});

module.exports = { toggleStyles };
